import {createSlice, PayloadAction} from '@reduxjs/toolkit';

type IdentityVerificationParams = {
  eventName: string | undefined;
  picture?: string | undefined;
  type?: string | undefined;
};

const initialState: IdentityVerificationParams = {
  eventName: undefined,
};

const IdentityVerificationParamSlice = createSlice({
  name: 'IDVerificationParamSlice',
  initialState,
  reducers: {
    setCurrentEvent(state, action: PayloadAction<IdentityVerificationParams>) {
      state.eventName = action.payload.eventName;
      state.type = action.payload.type;
      state.picture = action.payload.picture;
    },
  },
});

export const {setCurrentEvent} = IdentityVerificationParamSlice.actions;

export default IdentityVerificationParamSlice.reducer;
